import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Region from '@/components/Region'
import Rack from '@/components/Rack'
import Sample from '@/components/Sample'
import RegionNew from '@/components/RegionNew'
import Position from '@/components/Position'
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
   {
      path: '/Region',
      name: 'Region',
      component: Region
    },
    {
      path: '/RegionNew',
      name: 'RegionNew',
      component: RegionNew
    },
    
    {
      path: '/Rack',
      name: 'Rack',
      component: Rack
    },
    {
      path: '/Sample',
      name: 'Sample',
      component: Sample
    },
    {
      path: '/Position',
      name: 'Position',
      component: Position
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js